import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import '@forevolve/bootstrap-dark/dist/css/bootstrap-dark.min.css'

import 'bootstrap-vue/dist/bootstrap-vue.css'
// import './assets/bootstrap.min.css'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
